import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './kristenelaine-v11';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
